<template>
  <footer class="footer z-index-0 mt-md-0 mt-5">
    <div class="container position-relative">
      <div class="d-flex flex-column flex-md-row-reverse wrapper justify-content-between">
        <nav class="d-flex flex-row wrapper justify-content-between">
          <router-link :to="{ name: 'privacy-policy' }" class="link">
            {{ $t('privacyPolicyPage.title') }}
          </router-link>

          <router-link :to="{ name: 'cookie-policy' }" class="link">
            {{ $t('cookiePolicyPage.title') }}
          </router-link>
        </nav>

        <p class="copyright">© {{ thisYear }} {{ $t('footer.copyright') }}</p>
      </div>

      <button type="button" class="btn btn-primary floating-btn" @click="openFreshChat">
        <span class="d-inline-flex align-items-center">
          {{ $t('footer.consultationCTA') }}
        </span>

        <img aria-hidden="true" src="/images/svg/chat-rectangle.svg" height="24" alt="" />
      </button>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    thisYear() {
      const d = new Date();
      return d.getFullYear();
    },
  },
  methods: {
    openFreshChat() {
      window.fcWidget.open();
    },
  },
};
</script>
